import service from "./service"

const preAdverseActionResponseContext = async (responseKey) => {
    return service(responseKey)
}

export default preAdverseActionResponseContext
